import { combineEpics } from "redux-observable";
import { epicLandingPageLogoutConfirmation } from "./epicLandingPageLogoutConfirmation";
import { epicLandingPageLogoutRequest } from "./epicLandingPageLogoutRequest";
export var epicLandingPageLogout = combineEpics(epicLandingPageLogoutRequest, epicLandingPageLogoutConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/epicLandingPageLogout.ts
// module id = 1981
// module chunks = 3